import type { ITracking } from './ITracking';
import type { FC, PropsWithChildren } from 'react';
import { TrackingContext } from './TrackingProvider';

const emptyTracker: ITracking = {
  trackStructuredEvent(): Promise<void> {
    return Promise.resolve();
  },
  initialize() {
    return;
  },
};

export const EmptyTrackingProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <TrackingContext.Provider value={emptyTracker}>
      {children}
    </TrackingContext.Provider>
  );
};
